import script from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=6c768f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c768f00"]])

export default __exports__